import api from './authService';

export const adminVendorDocumentsApi = {
  getSummary: async (vendorUserId) => {
    const response = await api.get(`/admin/vendors/${vendorUserId}/documents-summary`);
    return response.data;
  },

  getInvoices: async (vendorUserId, params = {}) => {
    const response = await api.get(`/admin/vendors/${vendorUserId}/invoices`, { params });
    return response.data;
  },

  getInvoice: async (vendorUserId, invoiceId) => {
    const response = await api.get(`/admin/vendors/${vendorUserId}/invoices/${invoiceId}`);
    return response.data;
  },

  getContracts: async (vendorUserId, params = {}) => {
    const response = await api.get(`/admin/vendors/${vendorUserId}/contracts`, { params });
    return response.data;
  },

  getContract: async (vendorUserId, contractId) => {
    const response = await api.get(`/admin/vendors/${vendorUserId}/contracts/${contractId}`);
    return response.data;
  },
};
